<template>
    <div class="io-filterables">
        <div class="row g-3 mb-3">
            <div class="col-12">
                <md-field class="bordered search">
                    <label>Filtern</label>
                    <md-input v-model="filterString" @input="filterItems"></md-input>
                </md-field>
            </div>
        </div>
        <div class="io-filterables-cont">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import IoFilterable from './IoFilterable';

export default {
  name: 'IoFilterables',

  components: {
    IoFilterable,
  },

  data() {
    return {
      filterString: '',
      filterables: [],
    };
  },

  mounted() {
    for (let i = 0; i < this.$children.length; i++) {
      const child = this.$children[i];
      if (child.$el.classList.contains('io-filterable')) {
        this.filterables.push(child);
      }
    }
  },

  methods: {
    filterItems() {
      for (let i = 0; i < this.filterables.length; i++) {
        this.filterables[i].visible = true;
      }
      if (this.filterString.trim() !== '') {
        for (let i = 0; i < this.filterables.length; i++) {
          if (!this.filterables[i].tag.toLowerCase().includes(this.filterString.trim().toLowerCase())) {
            this.filterables[i].visible = false;
          }
        }
      }
    },
  },
};
</script>
